<template>
  <popup-layout :title="'동영상 ' + typeText" width="600" :is-show="isShow">
    <template v-slot:content>
      <field-input title="제목(필수항목)">
        <v-text-field
            v-model="videoData.title"
            placeholder="영상 제목을 입력해주세요"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="링크(필수항목)">
        <v-text-field
            v-model="videoData.url"
            placeholder="영상 링크를 입력해주세요"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="영상 시간">
        <v-text-field
            v-model="videoData.playTime"
            placeholder="00:00"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="영상 카테고리">
        <v-select
            v-model="videoData.categoryId"
            :items="categoryList"
            item-text="categoryNm"
            item-value="categoryId"
            placeholder="선택"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
      <field-input title="노출여부">
        <v-select
            v-model="videoData.useYn"
            :items="useYnList"
            item-text="text"
            item-value="value"
            placeholder="선택"
            outlined hide-details dense
            background-color="white"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="isSave">저장</v-btn>
        <v-btn class="button delete" outlined @click="closePopup">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>

<script>
import _ from "lodash";
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";

export default {
  name: "ManagePopup",
  components: {FieldInput, PopupLayout},
  props: ["isShow", "type", "categoryList", "useYnList", "videoDataProps"],

  data() {
    return {
      videoData: {
        title: "",
        url: "",
        playTime: "",
        categoryId: null,
        useYn: ""
      }
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId"
    }),
    typeText(){
      return this.type === 'new' ? '업로드' : '수정';
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        if (!_.isEmpty(this.videoDataProps)) {
          this.videoData = _.cloneDeep(this.videoDataProps);
        }
      }
    }
  },
  methods: {
    isSave() {
      if (
          _.isEmpty(this.videoData.title) ||
          _.isEmpty(this.videoData.url) ||
          this.videoData.categoryId === null ||
          _.isEmpty(this.videoData.playTime) ||
          _.isEmpty(this.videoData.useYn)
      ) {
        this.showAlert({message: "입력정보를 다시한번 확인해주세요"});
        return false;
      }
      this.showConfirm({
        message: `동영상을 ${this.typeText} 하시겠습니까?`,
        successCallback: () => {
          if (this.type === "new") {
            this.save();
          } else {
            this.modify();
          }
        },
        failCallback: () => {
          return false;
        }
      });
    },
    async save() {
      const trainingInfo = {
        categoryId: this.videoData.categoryId,
        title: this.videoData.title,
        url: this.videoData.url,
        playTime: this.videoData.playTime,
        createId: this.memberId
      };
      try {
        await axiosInstance.put("/admin/training/training", trainingInfo)
            .then(() => {
              this.showAlert({
                message: "동영상 등록이 완료되었습니다",
                successCallback: () => {
                  this.setDefaultData();
                  this.$emit("refresh");
                  this.closePopup();
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async modify() {
      const trainingInfo = _.cloneDeep(this.videoData);
      try {
        await axiosInstance.patch("/admin/training/training", trainingInfo)
            .then(() => {
              this.showAlert({
                message: "동영상 수정이 완료되었습니다",
                successCallback: () => {
                  this.setDefaultData();
                  this.$emit("refresh");
                  this.closePopup();
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    setDefaultData() {
      this.videoData = {
        title: "",
        url: "",
        playTime: "",
        categoryId: null,
        useYn: ""
      };
    },
    closePopup() {
      this.setDefaultData();
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
}
</style>